import React, { useState, useRef, useEffect } from 'react'
import RightNav from './RightNav'

export default function BurguerButton(): React.ReactElement {
    const [isOpen, setIsOpen] = useState(false)
    const menuRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent): void => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false)
            }
        }

        document.addEventListener('mousedown', handleOutsideClick)

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick)
        }
    }, [menuRef])

    return (
        <div className="burguer-button" ref={menuRef}>
            <input type="checkbox" checked={isOpen} onChange={() => setIsOpen((current) => !current)} />
            <span />
            <span />
            <span />
            {isOpen && (
                <div className="rightNav">
                    <RightNav />
                </div>
            )}
        </div>
    )
}
